module.exports = __webpack_public_path__ + "static/media/7.7c9c0092.jpg";